import { createApp } from 'vue';
import App from './AppPrelaunch.vue';
import router from './routes';
import store from '@common/store';
import '@common/logger';
import { auth, usersCollection } from '@common/firebase';
import i18n from './i18n';
import { createHead } from '@unhead/vue'

const init = async () => {
  let appInstance;
  const head = createHead()
  const googleAnalyticsID = process.env.NODE_ENV === 'production' ? 'G-K5ENG81CLC' : 'G-V796XJFBPB';

  // Detect if running in prerendering mode (headless browser)
  const isPrerendering = window.location.search.includes('prerender=true') ||
                         navigator.userAgent.includes('HeadlessChrome');

  if (isPrerendering) {
    // Prerendering mode: mount app immediately without Firebase Auth
    console.log('🎨 Prerendering mode detected - bypassing Firebase Auth');

    // Force French locale for pre-rendering (default market)
    i18n.global.locale = 'fr';

    appInstance = createApp(App)
      .use(router)
      .use(store)
      .use(i18n)
      .use(head)
      .mount('#app');

    // Signal that app is ready for pre-rendering
    router.isReady().then(() => {
      setTimeout(() => {
        document.dispatchEvent(new Event('app-rendered'));
        console.log('✓ App rendered event dispatched');
      }, 500); // Give more time for @unhead to inject meta tags
    });

    return;
  }

  // Normal mode: use Firebase Auth without overriding an existing session
  auth.onAuthStateChanged(async (user) => {
    if (!user) {
      // Only sign in anonymously if no user is currently signed in
      try {
        await auth.signInAnonymously();
      } catch (e) {
        console.error('Anonymous sign-in failed:', e);
      }
      return;
    }

    // We have a user (anonymous or authenticated)
    store.commit('setAuthUser', user);

    usersCollection.doc(user.uid).onSnapshot((snapshot) => {
      console.log(
        'Build:',
        process.env.NODE_ENV === 'production' ? 'production' : 'development'
      );

      if (!appInstance) {
        // Create and mount the Vue 3 application
        appInstance = createApp(App)
          .use(router)
          .use(store)
          .use(i18n)
          // Unhead plugin for SEO on SPA
          .use(head)
          .mount('#app');

        // Signal to prerender-spa-plugin that the app is ready
        router.isReady().then(() => {
          setTimeout(() => {
            document.dispatchEvent(new Event('app-rendered'));
            console.log('App rendered event dispatched for pre-rendering');
          }, 100);
        });
      }

      if (snapshot.data()) {
        store.commit('setUserProfile', snapshot.data());
      }
    });
  });
};

init();
